/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyResourceData {
    getFixupPrototypeFunction() { return CostAnomalyResourceData.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyResourceData>): CostAnomalyResourceData {
        let obj = Object.assign(new CostAnomalyResourceData(), model);
        CostAnomalyResourceData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyResourceData>): CostAnomalyResourceData {
        if (!model) return null;
        return CostAnomalyResourceData.newInstance(<CostAnomalyResourceData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyResourceData) {
        if (!obj) return;

        models.CostAnomalyResourceData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyResourceData): boolean {
        Object.setPrototypeOf(obj, CostAnomalyResourceData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.billed_cost) {
            for (let val of this.billed_cost) {
                models.CostAnomalyBilledCost.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the resource
     */
    resource_id: string;

    /**
     * Billed cost for the resource
     */
    billed_cost: Array<models.CostAnomalyBilledCost>;

}
